var _path, _path2, _path3, _path4, _rect, _path5, _rect2, _path6, _rect3, _rect4, _path7, _path8, _path9, _rect5, _rect6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect7, _rect8, _rect9, _path25, _rect10, _path26, _rect11, _g, _g2, _path27, _g3, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 956,
    height: 918,
    viewBox: "0 0 956 918",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M720.168 699.288L551.55 796.64L382.932 893.992L382.932 912.961L720.168 718.257L720.168 699.288Z",
    fill: "#EA80FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M577.853 616.366L409.183 713.748L240.513 811.13L382.828 893.295L720.167 698.532L577.853 616.366Z",
    fill: "#EA80FC",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.485 578.106L254.346 630.726L163.206 683.345L269.605 744.774L451.884 639.536L345.485 578.106Z",
    fill: "#FFCCBC",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.662 281.035L102.13 266.1L101.212 674.006L127.662 689.276L127.662 281.035Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 282.511,
    height: 296.111,
    transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 696.337 234.586)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M595.132 504.216L427.434 405.855L427.434 494.909L595.132 593.27L595.132 504.216Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 119.622,
    height: 120.354,
    transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 799.933 473.445)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M379.59 893.293L239.444 812.769L239.444 832.322L380.868 912.787L379.59 893.293Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 122.167,
    height: 12.6267,
    transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 270.548 743.183)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 30.5417,
    height: 116.853,
    transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 281.566 565.346)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M281.566 548.326L320.139 526.056L358.712 503.786L358.712 638.008L281.566 682.548L281.566 548.326Z",
    fill: "#FFCCBC",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M452.485 650.166L361.515 702.687L270.545 755.209L270.545 745.164L452.485 640.121L452.485 650.166Z",
    fill: "#FFCCBC",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M806.543 190.663L576.923 58.0923L466.367 121.922L695.987 254.493L806.543 190.663Z",
    fill: "#B0BEC5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 265.142,
    height: 113.7,
    transform: "matrix(-0.866025 -0.5 -0.866025 0.5 696.337 446.663)",
    fill: "#B0BEC5",
    stroke: "#263238",
    strokeWidth: 4.71381
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 118.527,
    height: 127.659,
    transform: "matrix(-0.866025 -0.5 -0.866025 0.5 908.802 410.831)",
    fill: "#B0BEC5",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M805.788 191.419L750.338 224.045L696.336 255.223L696.336 414.269L804.34 351.913L805.788 191.419Z",
    fill: "#B0BEC5",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M907.935 413.283L853.933 444.461L799.931 475.639L799.931 592.74L907.935 530.384L907.935 413.283Z",
    fill: "#B0BEC5",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M696.337 446.357L646.743 474.99L597.15 503.622L597.15 593.273L696.337 536.007L696.337 446.357Z",
    fill: "#B0BEC5",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M587.147 63.6447L609.969 77.4038",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M562.419 0L332.092 132.979L101.766 265.958L128.006 281.108L588.659 15.1499L562.419 0Z",
    fill: "#FFCCBC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M588.335 13.5242L358 146.508L127.666 279.491L127.666 689.535L588.335 423.568L588.335 13.5242Z",
    fill: "#FFCCBC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M575.108 31.3651C576.236 30.7143 577.15 31.2419 577.15 32.5436L577.15 392.017C577.15 393.319 576.236 394.902 575.108 395.553L145.298 643.704C144.17 644.355 143.257 643.827 143.257 642.526L143.257 283.052C143.257 281.75 144.17 280.167 145.298 279.516L360.203 155.441L575.108 31.3651Z",
    fill: "#EEFF41",
    stroke: "#263238",
    strokeWidth: 4.71381,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.188 512.467L231.271 510.11L231.271 519.537L227.188 521.894L227.188 512.467ZM171.232 552.82C169.638 551.899 169.638 548.915 171.232 546.154L197.212 501.156C198.806 498.395 201.391 496.902 202.985 497.823C204.579 498.743 204.579 501.728 202.985 504.489L179.892 544.487L202.985 557.82C204.579 558.74 204.579 561.725 202.985 564.486C201.391 567.247 198.806 568.74 197.212 567.819L171.232 552.82ZM227.188 521.894L174.119 552.534L174.119 543.106L227.188 512.467L227.188 521.894Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M312.034 468.154L316.116 465.797L316.116 475.225L312.034 477.582L312.034 468.154ZM256.078 508.507C254.484 507.587 254.484 504.602 256.078 501.841L282.057 456.843C283.652 454.082 286.236 452.59 287.831 453.51C289.425 454.431 289.425 457.415 287.831 460.177L264.738 500.174L287.831 513.507C289.425 514.428 289.425 517.412 287.831 520.173C286.236 522.935 283.652 524.427 282.057 523.507L256.078 508.507ZM312.034 477.582L258.965 508.221L258.965 498.794L312.034 468.154L312.034 477.582Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M397.831 421.961L401.913 419.604L401.913 429.031L397.831 431.388L397.831 421.961ZM341.875 462.314C340.281 461.393 340.281 458.409 341.875 455.648L367.854 410.65C369.449 407.889 372.033 406.396 373.628 407.317C375.222 408.237 375.222 411.222 373.628 413.983L350.535 453.981L373.628 467.314C375.222 468.234 375.222 471.219 373.628 473.98C372.033 476.741 369.449 478.234 367.854 477.313L341.875 462.314ZM397.831 431.388L344.761 462.028L344.761 452.6L397.831 421.961L397.831 431.388Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M526.215 714.554L534.842 695.966L558.411 709.574L526.215 714.554ZM560.914 696.878L546.626 705.127L542.544 702.77L556.832 694.521L560.914 696.878Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M625.809 661.76L617.182 680.348L593.613 666.741L625.809 661.76ZM591.109 679.437L605.397 671.188L609.479 673.545L595.192 681.794L591.109 679.437Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M625.809 714.554L593.613 709.574L617.182 695.966L625.809 714.554ZM595.192 694.521L609.48 702.77L605.397 705.127L591.109 696.878L595.192 694.521Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M526.215 661.76L558.411 666.741L534.842 680.348L526.215 661.76ZM556.832 681.794L542.544 673.545L546.626 671.188L560.914 679.437L556.832 681.794Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M754.657 222.417L727.306 312.604L782.008 281.021L754.657 222.417Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 20.7407,
    height: 82.6688,
    transform: "matrix(-0.866025 0.5 2.20305e-08 1 764.558 289.976)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 20.7407,
    height: 112.175,
    transform: "matrix(-0.866025 0.5 2.20305e-08 1 866.381 439.612)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 20.7407,
    height: 113.126,
    transform: "matrix(-0.866025 0.5 0.866025 0.5 768.383 376.709)",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.969 176.841C131.969 171.634 128.313 169.523 123.804 172.127L102.423 184.471C97.9137 187.075 94.2583 193.406 94.2583 198.613L94.2583 225.109C94.2583 230.315 97.9137 232.426 102.423 229.822L123.804 217.478C128.313 214.875 131.969 208.543 131.969 203.337L131.969 176.841Z",
    fill: "#263238"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 43.5443,
    height: 50.422,
    rx: 9.42761,
    transform: "matrix(-0.866025 0.5 2.20305e-08 1 184.764 91.9905)",
    stroke: "#263238",
    strokeWidth: 3.31488
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M141.863 179.688C141.863 174.481 138.208 172.371 133.699 174.974L112.317 187.319C107.808 189.922 104.153 196.253 104.153 201.46L104.153 227.956C104.153 233.163 107.808 235.273 112.317 232.67L133.699 220.325C138.208 217.722 141.863 211.391 141.863 206.184L141.863 179.688Z",
    fill: "#EA80FC",
    stroke: "#263238",
    strokeWidth: 3.31488
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 43.5443,
    height: 50.422,
    rx: 9.42761,
    transform: "matrix(-0.866025 0.5 2.20305e-08 1 191.361 95.7621)",
    fill: "#FF1744",
    stroke: "#263238",
    strokeWidth: 3.31488
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_412_8735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.232 92.9006C116.232 87.6939 112.577 85.5835 108.068 88.1868L91.4003 97.8098C86.8912 100.413 83.2358 106.745 83.2358 111.951L83.2358 135.867C83.2358 141.074 86.8912 143.184 91.4003 140.581L108.068 130.958C112.577 128.354 116.232 122.023 116.232 116.816L116.232 92.9006Z",
    fill: "#EA80FC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_412_8735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.891 98.592C124.891 93.3853 121.235 91.2749 116.726 93.8782L100.059 103.501C95.5494 106.105 91.894 112.436 91.894 117.643L91.894 137.753C91.894 142.96 95.5494 145.07 100.059 142.467L116.726 132.844C121.235 130.241 124.891 123.909 124.891 118.703L124.891 98.592Z",
    fill: "#EEFF41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.891 98.592C124.891 93.3853 121.235 91.2749 116.726 93.8782L100.059 103.501C95.5494 106.105 91.894 112.436 91.894 117.643L91.894 137.753C91.894 142.96 95.5494 145.07 100.059 142.467L116.726 132.844C121.235 130.241 124.891 123.909 124.891 118.703L124.891 98.592Z",
    stroke: "#263238",
    strokeWidth: 3.31488
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_412_8735",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 33,
    width: 431,
    height: 609
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M575.106 33.6727L360.201 157.748L145.296 281.824L145.296 641.298L575.106 393.147L575.106 33.6727Z",
    fill: "#EEFF41"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_412_8735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.639 346.214L210.669 227.886L127.504 276.766L560.63 415.991L593.639 397.21V346.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.979 238.574L330.749 166.266L295.437 187.197L582.979 269.97V238.574Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M540.193 210.346L540.193 210.342C538.453 193.17 536.757 180.043 534.305 170.413C531.867 160.836 528.592 154.336 523.396 150.864C518.506 147.503 512.088 146.828 503.798 147.833C495.492 148.839 484.978 151.578 471.655 155.401L471.646 155.404L470.526 155.732L471.542 155.106C499.415 137.983 515.189 126.753 524.86 110.501C534.507 94.2865 537.972 73.2487 541.944 36.9286L541.944 36.9258L542.079 35.6716L542.2 36.897L542.2 36.9011C543.941 54.0736 545.636 67.2007 548.091 76.8359C550.533 86.4187 553.813 92.9262 559.018 96.4184C563.895 99.7992 570.375 100.437 578.679 99.4186C587.008 98.397 597.521 95.6592 610.717 91.9098L610.724 91.9079L610.731 91.9059L611.854 91.5766L610.876 92.1795C610.875 92.1799 610.874 92.1802 610.874 92.1805C583.003 109.303 567.223 120.522 557.549 136.769C547.898 152.978 544.434 174.016 540.474 210.357L540.327 211.701L540.193 210.346Z",
    fill: "#FF1744",
    stroke: "#263238",
    strokeWidth: 3.31488
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M122.018 767.134L122.018 767.13C120.269 749.875 118.565 736.686 116.102 727.011C113.652 717.388 110.362 710.859 105.144 707.373C100.233 703.997 93.7862 703.319 85.4579 704.328C77.1121 705.34 66.5481 708.091 53.1617 711.932L53.1522 711.935L51.971 712.282L53.0422 711.621C81.0487 694.416 96.8967 683.133 106.612 666.805C116.305 650.515 119.786 629.379 123.777 592.884L123.777 592.881L123.921 591.545L124.05 592.852L124.051 592.857C125.799 610.111 127.503 623.301 129.97 632.982C132.423 642.61 135.718 649.146 140.945 652.653C145.843 656.049 152.352 656.69 160.695 655.667C169.064 654.64 179.626 651.889 192.886 648.122L192.893 648.12L192.9 648.118L194.084 647.771L193.051 648.407C193.051 648.408 193.05 648.408 193.049 648.408C165.045 665.613 149.191 676.885 139.472 693.207C129.776 709.492 126.295 730.63 122.316 767.145L122.16 768.571L122.018 767.134Z",
    fill: "#FF1744",
    stroke: "#263238",
    strokeWidth: 3.31488
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M925.789 278.231C922.029 279.27 912.122 256.451 908.676 254.38C905.23 252.308 889.855 255.677 889.189 251.951C888.523 248.224 902.344 238.974 904.222 235.411C906.1 231.848 906.439 214.897 910.112 214.151C913.785 213.405 924.057 229.35 927.592 231.213C931.128 233.075 947.248 231.823 947.651 235.677C948.055 239.531 934.089 246.754 932.046 250.181C930.003 253.609 929.548 277.192 925.789 278.231Z",
    fill: "#FF1744"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M865.748 320.083C863.705 319.643 864.664 306.352 863.542 304.514C862.42 302.675 854.285 300.46 854.893 298.525C855.502 296.591 864.358 295.629 866.134 294.403C867.909 293.178 872.276 285.214 874.205 285.772C876.134 286.329 877.054 296.447 878.27 298.209C879.487 299.97 887.45 303.375 886.685 305.305C885.921 307.235 877.499 307.199 875.678 308.319C873.858 309.439 867.791 320.522 865.748 320.083Z",
    fill: "#FF1744"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2612 792.47C76.2742 793.116 70.4243 781.143 68.5306 780.117C66.6368 779.092 58.49 781.264 58.0441 779.286C57.5983 777.308 64.7721 772.026 65.6914 770.074C66.6108 768.122 66.3849 759.043 68.3324 758.555C70.28 758.068 76.16 766.354 78.0967 767.266C80.0333 768.177 88.6297 767.12 88.9381 769.172C89.2465 771.225 81.9466 775.426 80.9358 777.309C79.9251 779.193 80.2482 791.823 78.2612 792.47Z",
    fill: "#FF1744"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M177.335 660.251L378.386 544.611",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M388.905 538.035L407.851 527.147",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M382.613 893.594V915.067L542.019 821.879",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M555.695 813.366L600.058 787.09",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M614.156 779.414L621.956 774.538",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M720.929 699.288V718.406L691.787 735.425",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M101.733 266.054L458.403 60.7794",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M496.087 38.5278L545.215 9.86792",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M806.424 190.43L728.774 145.621",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M714.823 137.375L660.313 105.928",
    stroke: "#263238",
    strokeWidth: 4.41984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_412_8735",
    x: 75.6933,
    y: 79.5297,
    width: 48.0812,
    height: 69.7082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3.77104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_412_8735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_412_8735",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_412_8735",
    x: 86.6879,
    y: 87.1386,
    width: 43.4093,
    height: 62.068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.88552
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_412_8735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_412_8735",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.e7e646ac9c5bd1281543705e4e3c611e.svg";
export { ForwardRef as ReactComponent };